<script setup lang="ts">
import { computed } from 'vue';

import cat from './avatars/cat.svg?url';
import bunny from './avatars/bunny.svg?url';
import bear from './avatars/bear.svg?url';
import penguin from './avatars/penguin.svg?url';
import duck from './avatars/duck.svg?url';
import fox from './avatars/fox.svg?url';
import whale from './avatars/whale.svg?url';
import frog from './avatars/frog.svg?url';
import seal from './avatars/seal.svg?url';
import dog from './avatars/dog.svg?url';

const props = defineProps<{ seed: string }>();
const illustrations = [cat, bunny, bear, penguin, duck, fox, whale, frog, seal, dog] as const;

// 只用稳定身份挑选本地插画，同一人在列表、资料和消息中保持同一头像。
const illustration = computed(() => {
  let hash = 2_166_136_261;
  for (let index = 0; index < props.seed.length; index += 1) {
    hash = Math.imul(hash ^ props.seed.charCodeAt(index), 16_777_619);
  }
  return illustrations[(hash >>> 0) % illustrations.length];
});
</script>

<template>
  <span class="default-avatar" aria-hidden="true">
    <img :src="illustration" alt="" draggable="false" />
  </span>
</template>

<style scoped>
.default-avatar {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border: 1px solid #dbecef;
  border-radius: 50%;
  background: #f2fafb;
}

.default-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
